"use client";

import { c as _c } from "react/compiler-runtime";
import { FiAlertTriangle } from "react-icons/fi";
import { formatDayWithOrdinal } from "@/lib/format-data";
import { ProvidersBack } from "@/lib/self-schedule-next-shift";
import { cx } from "@/lib/tailwind-utils";
interface NoticeProps {
  until: ProvidersBack;
  // A telehealth visit isn't "here".
  isVirtual?: boolean;
}
const NoAppointmentsText = t0 => {
  const $ = _c(3);
  const {
    until,
    isVirtual
  } = t0;
  const where = isVirtual ? "" : " here";
  let t1;
  if ($[0] !== until || $[1] !== where) {
    t1 = until === "indefinitely" ? <span>No appointments{where} right now</span> : <span>No appointments{where} until{" "}<span className="whitespace-nowrap">{formatDayWithOrdinal(until)}</span></span>;
    $[0] = until;
    $[1] = where;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/** A strip for the bottom edge of a location card. */
export const LocationCardNotice = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FiAlertTriangle className="mt-px size-3.5 shrink-0 text-primary-foreground/80" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <p className="flex items-start gap-1.5 bg-primary px-5 py-2 text-caption-strong text-primary-foreground">{t0}<NoAppointmentsText {...props} /></p>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/** The same note under the Choose a Time heading. */
export const LocationNoticeLine = t0 => {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cx("flex w-fit items-start gap-1.5 rounded-xl bg-primary px-4 py-2 text-body-strong text-primary-foreground md:shadow-md", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FiAlertTriangle className="mt-0.5 size-4 shrink-0 text-primary-foreground/80" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props) {
    t3 = <NoAppointmentsText {...props} />;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <p className={t1}>{t2}{t3}</p>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};